import type { FC } from 'react';
import {
  Button,
  Card,
  Flex,
  Heading,
  Image,
  Text,
} from '@highereducation/hen-ui';
import type { SubmittedProgram } from '../ResultsPage/types';

type SubmissionsCardProps = {
  data: SubmittedProgram;
  position: number;
  onViewNextSteps?: (submission: SubmittedProgram) => void;
};

const SubmissionsCard: FC<SubmissionsCardProps> = ({
  data,
  onViewNextSteps,
}) => {
  const imageUrl = `https://simple-storage-server.highereducation.com/${data.school.slug}.png?w=130&h=80`;

  const handleClick = () => {
    if (onViewNextSteps) {
      onViewNextSteps(data);
    }
  };

  return (
    <Card variant='background-white' rounded='md' border='shadow'>
      <Flex
        direction='column'
        direction-lg='row'
        align='stretch'
        justify='between'
        gap='md'
        width='full'
        className='lg:items-center'
      >
        <Flex direction='row' align='center' gap='md' asChild>
          <header>
            <Image
              src={imageUrl}
              alt={`${data.school.name} logo`}
              width={130}
              height={80}
              objectFit='contain'
            />

            <Flex direction='column' gap='none'>
              <Text variant='b5' weight='bold' className='text-primary-700'>
                {data.program.name}
              </Text>
              <Heading variant='h4'>{data.school.name}</Heading>
            </Flex>
          </header>
        </Flex>
        <Button
          variant='primaryFill'
          size='lg'
          type='button'
          onClick={handleClick}
          className='w-full lg:w-auto'
        >
          Next Steps
        </Button>
      </Flex>
    </Card>
  );
};

export default SubmissionsCard;
